/**
 * SkillDelivery Platform — WMS Showcase
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Content authored by Lalit Ratwani, drawing from 22+ years of
 * Manhattan WMS implementation practice (2003-2026).
 *
 * Maps showcase_modules.module_key → a lucide-react icon component.
 * Used by KnowledgeModuleCard so the cards stay icon-agnostic.
 */

import { Truck, Package, Archive, Layers, Smartphone, Plug, Box } from 'lucide-react';

const MODULE_ICONS = {
  inbound: Truck,
  outbound: Package,
  inventory: Archive,
  'wave-mgmt': Layers,
  'rf-operations': Smartphone,
  integrations: Plug,
};

export const getModuleIcon = (moduleKey) => MODULE_ICONS[moduleKey] || Box;

export default getModuleIcon;
